/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type AccommodationBookingGroupPageContentResponseModelContentType = typeof AccommodationBookingGroupPageContentResponseModelContentType[keyof typeof AccommodationBookingGroupPageContentResponseModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccommodationBookingGroupPageContentResponseModelContentType = {
  accommodationBookingGroupPage: 'accommodationBookingGroupPage',
} as const;
